<template>
  <div class="debt-items">
    <Loader v-if="loaderEnabled" v-bind:logo="loaderLogo"></Loader>
    <KTCodePreview v-bind:title="' '">
      <template v-slot:toolbar>
        <div class="row">
          <div>
            <b-dropdown size="sm" id="dropdown-1" right>
              <template slot="button-content">
                <i style="font-size: 1rem" class="fas fa-cog"></i>
                <span class="font-weight-bolder">Thao tác</span>
              </template>
              <b-dropdown-item @click="showModalExcel">
                <span>
                  <i style="font-size: 1rem" class="far fa-file-excel"></i>
                  &nbsp; Xuất Excel</span
                >
              </b-dropdown-item>
              <b-dropdown-item
                :to="{
                  name: 'import-debt',
                  params: {
                    mode: 'items',
                  },
                }"
                v-if="isShow(['TRANSACTION_IMPORT_EXCEL'])"
              >
                <span style="color: black">
                  <i style="font-size: 1rem" class="far fa-file-excel"></i>
                  &nbsp; Nhập từ Excel</span
                >
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </template>
      <template v-slot:preview>
        <b-row class="mb-5">
          <b-col>
            <b-form>
              <Autosuggest
                :model="searchStock"
                :suggestions="filteredOptions"
                placeholder="cửa hàng"
                :limit="10"
                @select="onSelected"
                @change="onInputChangeStore"
                :disabled="isDisabled"
              />
            </b-form>
          </b-col>
          <b-col>
            <div class="date-style">
              <b-input-group>
                <date-picker
                  placeholder="Từ"
                  class="form-control form-control-sm"
                  :config="dpConfigs.date"
                  v-model="apiParams.fromDate"
                ></date-picker>
              </b-input-group>
              <span class="ml-1 mr-1"></span>
              <b-input-group>
                <date-picker
                  placeholder="Đến"
                  class="form-control form-control-sm"
                  :config="dpConfigs.date"
                  v-model="apiParams.toDate"
                ></date-picker>
              </b-input-group>
            </div>
          </b-col>
          <b-col>
            <b-form>
              <b-form-select
                v-model="apiParams.contactId"
                :options="listInstallments"
                size="sm"
                class="select-style"
              ></b-form-select>
            </b-form>
          </b-col>
          <b-col>
            <b-input
              placeholder="Mã HĐ"
              v-model="apiParams.contractCode"
              size="sm"
            />
          </b-col>
          <b-col>
            <b-input
              placeholder="Chứng từ"
              v-model="apiParams.docId"
              size="sm"
            />
          </b-col>
        </b-row>
        <b-row class="mb-5">
          <b-col>
            <b-form>
              <b-input
                placeholder="Tìm chính xác SĐT KH"
                v-model="apiParams.customerMobile"
                size="sm"
              />
            </b-form>
          </b-col>
          <b-col>
            <b-form>
              <b-form-select
                v-model="apiParams.isFullPaid"
                :options="optionPaidStatus"
                size="sm"
                class="select-style"
              ></b-form-select>
            </b-form>
          </b-col>
          <b-col>
            <b-button
              style="font-weight: 600; width: 70px"
              variant="primary"
              size="sm"
              @click="handleFilter()"
              :disabled="btnDisable"
            >
              Lọc
            </b-button>
          </b-col>
          <b-col></b-col>
          <b-col></b-col>
        </b-row>

        <!-- LIST DATA -->
        <b-row>
          <b-col md="12" lg="12" sm="12">
            <b-table-simple
              bordered
              hover
              class="tbody-hover"
              v-if="!onLoadingList"
            >
              <b-thead>
                <b-tr>
                  <b-th class="text-center tdDate">Ngày</b-th>
                  <b-th class="text-center tdStore">Cửa hàng</b-th>
                  <b-th class="text-center tdCustomer">Khách hàng</b-th>
                  <b-th class="text-center tdProductName">Dịch vụ trả góp</b-th>
                  <b-th class="text-center tdProductPrice">Mã hợp đồng</b-th>
                  <b-th class="text-center tdProductPrice">Tiền trả góp</b-th>
                  <b-th class="text-center tdTotalPayment">Đã thanh toán</b-th>
                  <b-th class="text-center tdTotalPayment">Còn lại</b-th>
                  <b-th class="text-center tdTotalAmount"
                    >Tổng tiền hoá đơn</b-th
                  >
                  <b-th class="text-center"></b-th>
                </b-tr>
              </b-thead>
              <b-tbody v-for="bill in mainList.data" :key="bill.id">
                <b-tr v-for="(item, index) in bill.payments" :key="index">
                  <b-td
                    :rowspan="bill.payments.length + 1"
                    class="tdDate"
                    v-show="isShowRow(bill.payments, item)"
                  >
                    {{ formatDate(bill.createdAt) }}
                    <div>
                      <router-link
                        :to="{
                          path: '/bills/update-bill',
                          query: { id: bill.billNumber },
                        }"
                        target="_blank"
                        >{{ bill.billNumber }}
                      </router-link>
                    </div>
                  </b-td>
                  <b-td
                    :rowspan="bill.payments.length + 1"
                    class="text-left tdStore"
                    v-show="isShowRow(bill.payments, item)"
                  >
                    {{ bill.store?.name }}
                  </b-td>
                  <b-td
                    :rowspan="bill.payments.length + 1"
                    class="text-left tdCenter tdCustomer"
                    v-show="isShowRow(bill.payments, item)"
                  >
                    <b> {{ bill.customerName }}</b>
                    <p>{{ bill.customerPhone }}</p>
                  </b-td>
                  <b-td class="text-left tdProductName">
                    <b> {{ item.accountName }}</b>
                  </b-td>
                  <b-td class="text-right tdProductPrice">
                    {{ item.code }}
                  </b-td>
                  <b-td class="text-right tdProductPrice">
                    {{ convertPrice(item?.amount) || 0 }}
                  </b-td>
                  <b-td
                    :rowspan="bill.payments.length + 1"
                    class="text-right tdCenter"
                    v-show="isShowRow(bill.payments, item)"
                    style="width: 10%; color: #3c763d; font-weight: 700"
                  >
                    {{ convertPrice(bill.sumAmountTransactions) }}
                  </b-td>
                  <b-td
                    :rowspan="bill.payments.length + 1"
                    class="text-right tdCenter"
                    v-show="isShowRow(bill.payments, item)"
                    style="width: 10%; color: #3c763d; font-weight: 700"
                  >
                    {{ convertPrice(bill.sumRemainTransaction) }}
                  </b-td>
                  <b-td
                    :rowspan="bill.payments.length + 1"
                    class="text-right tdCenter"
                    v-show="isShowRow(bill.payments, item)"
                    style="width: 10%; color: #3c763d; font-weight: 700"
                  >
                    {{ convertPrice(bill.totalAmount) }}
                  </b-td>
                  <b-td class="text-center" style="width: 5%">
                    <b-dropdown
                      size="sm"
                      id="dropdown-left"
                      right
                      no-caret
                      v-if="bill.sumRemainTransaction > 0"
                    >
                      <template slot="button-content">
                        <i
                          style="font-size: 1rem; padding-right: 0px"
                          class="flaticon2-settings"
                        ></i>
                      </template>
                      <b-dropdown-item o-caret @click="editModalPayment(bill)">
                        <span style="color: #3f4254; font-size: 12px">
                          <i class="flaticon2-pen" style="font-size: 1rem"></i>
                          &nbsp; Chỉnh sửa
                        </span>
                      </b-dropdown-item>
                      <b-dropdown-item
                        o-caret
                        @click="linkToTransaction(bill, item)"
                      >
                        <span style="color: #3f4254; font-size: 12px">
                          <i
                            style="font-size: 1rem"
                            class="far fa-money-bill-alt"
                          ></i>
                          &nbsp; Thanh toán bằng tiền mặt
                        </span>
                      </b-dropdown-item>
                      <b-dropdown-item>
                        <router-link
                          :to="{
                            name: 'transaction',
                            params: {
                              mainModelProp: {
                                contactType: '3',
                                reconciliationDocType: '1',
                                reconciliationDocItemId: item.id,
                                reconciliationBillId: bill.id,
                                reconciliationBillNumber: bill.billNumber,
                                type: '3',
                                contactId: item.paymentRefId,
                                contactName: item.accountName,
                                amount: item.amount,
                                note: getNoteForPay(bill, item),
                              },
                              mode: 'bank',
                              action: 'add',
                              id: 'new',
                            },
                          }"
                        >
                          <span style="color: #3f4254; font-size: 12px">
                            <i
                              style="font-size: 1rem"
                              class="fas fa-money-check-alt"
                            ></i>
                            &nbsp; Thanh toán bằng CK ngân hàng
                          </span>
                        </router-link>
                      </b-dropdown-item>
                    </b-dropdown>
                  </b-td>
                </b-tr>
              </b-tbody>
              <b-tfoot>
                <tr>
                  <td colspan="5" class="text-right">
                    <b>Tổng</b>
                  </td>
                  <td class="text-right">
                    <b>
                      {{
                        sumTotalAmount('sumAmountPayments', mainList.data)
                      }}</b
                    >
                  </td>
                  <td class="text-right">
                    <b>
                      {{
                        sumTotalAmount('sumAmountTransactions', mainList.data)
                      }}</b
                    >
                  </td>
                  <td class="text-right">
                    <b>
                      {{
                        sumTotalAmount('sumRemainTransaction', mainList.data)
                      }}
                    </b>
                  </td>
                  <td class="text-right">
                    <b>
                      {{ sumTotalAmount('totalAmount', mainList.data) }}
                    </b>
                  </td>
                  <td></td>
                </tr>
              </b-tfoot>
            </b-table-simple>
            <vcl-table
              v-if="onLoadingList"
              :speed="5"
              :animate="true"
              :columns="11"
            />
          </b-col>
        </b-row>
        <!-- PAGINATION -->
        <b-col>
          <BPaginationNavCustom
            :number-of-pages="paginations.totalPages || 1"
            :current-page="paginations.currentPage"
            :total-page="paginations.total"
            :link-params="getParamFilters()"
            @page-change="fetchMainData()"
          ></BPaginationNavCustom>
        </b-col>
      </template>
    </KTCodePreview>
    <DebtEditModal
      :item="bill"
      :mode="mbPaymentType"
      v-on:refresh="fetchMainData"
    />
    <template>
      <DebtExcel :param="getParamFilters()" :mode="mbPaymentType" />
    </template>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import ApiService from '@/core/services/api.service';
import moment from 'moment';
import _ from 'lodash';
import Loader from '@/view/content/Loader.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import { VclTable } from 'vue-content-loading';
import { getToastInstance } from '@/utils/toastHelper';
import { mapGetters } from 'vuex';
import { checkPermissions } from '@/utils/saveDataToLocal';
import { convertPrice } from '@/utils/common';
import DebtEditModal from '@/view/components/debt/DebtEditModal.vue';
import { getSubtractDate, getAddDate, formatDate } from '@/utils/date';
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import BPaginationNavCustom from '@/view/base/bootstrap/BPaginationNavCustom.vue';

import DebtExcel from '../../components/debt/DebtExcel.vue';

const MIN_RANGE_DATE = getSubtractDate(7);
const MAX_RANGE_DATE = getAddDate();

export default {
  name: 'DebtItems',

  components: {
    KTCodePreview,
    Loader,
    VclTable,
    Autosuggest,
    DebtEditModal,
    DebtExcel,
    BPaginationNavCustom,
  },

  data() {
    return {
      title: 'Công nợ trả góp hóa đơn theo ngày',
      listInstallments: [{ value: null, text: 'Tất cả dịch vụ trả góp' }],
      optionPaidStatus: [
        { value: null, text: 'Công nợ trả góp' },
        { value: 'true', text: 'Hết nợ' },
        { value: 'false', text: 'Còn nợ' },
      ],
      mainList: {
        data: [],
        total: 0,
        pages: 1,
      },
      paginations: {
        total: 0,
        totalPages: 1,
        currentPage: 1,
      },
      btnDisable: false,
      apiParams: {
        page: 1,
        limit: 10,
        storeId: null,
        fromDate: MIN_RANGE_DATE,
        toDate: MAX_RANGE_DATE,
        contactId: null,
        contractCode: null,
        docId: null,
        customerMobile: null,
        isFullPaid: null,
      },
      onLoadingList: false,
      dpConfigs: {
        date: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          showClear: true,
          showClose: true,
          minDate: false,
          maxDate: false,
          locale: 'vi',
          sideBySide: true,
        },
      },
      filteredOptions: [],
      optionsStore: [],
      searchStock: '',
      isDisabled: false,
      bill: {
        billNumber: null,
      },
      mbPaymentType: null,
      searchTimer: null,
      // Constanst
      PAGE_LIMIT: 10,
    };
  },

  computed: {
    ...mapGetters(['breadcrumbs', 'pageTitle', 'layoutConfig']),

    loaderEnabled() {
      return !/false/.test(this.layoutConfig('loader.type'));
    },

    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig('loader.logo');
    },

    hasData() {
      return this.mainList.data && this.mainList.data.length > 0;
    },
  },

  watch: {
    mode: {
      handler(newVal) {
        if (newVal) {
          this.fetchMainData();
          this.loadBreadcrumb();
        }
      },
      immediate: true,
    },

    '$route.query': {
      handler() {
        this.fetchMainData();
      },
      deep: true,
    },
  },

  async created() {
    try {
      this.setFilter();
      this.loadBreadcrumb();
      await Promise.all([this.fetchInstallments(), this.fetchStoreByUser()]);
    } catch (error) {
      this.handleError('Lỗi khởi tạo trang', error);
    }
  },

  mounted() {
    window.addEventListener('keyup', this.onFilterKeyEnter);
  },

  beforeDestroy() {
    window.removeEventListener('keyup', this.onFilterKeyEnter);
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
  },

  beforeRouteUpdate(to, from, next) {
    this.mode = to.params.mode;
    next();
  },

  methods: {
    ...getToastInstance(),

    // Utility methods
    convertPrice,
    formatDate,

    // Event handlers
    onFilterKeyEnter(event) {
      if (event.key === 'Enter') {
        this.handleFilter();
      }
    },

    handleFilter() {
      this.updateUrlParams();

      setTimeout(() => {
        this.btnDisable = false;
      }, 1000);
    },

    getParamFilters() {
      const params = {
        page: this.apiParams.page,
        limit: this.PAGE_LIMIT,
        storeId: this.apiParams.storeId,
        contactId: this.apiParams.contactId,
        fromDate: this.apiParams.fromDate
          ? moment(this.apiParams.fromDate, 'DD/MM/YYYY').format('DD/MM/YYYY')
          : null,
        toDate: this.apiParams.toDate
          ? moment(this.apiParams.toDate, 'DD/MM/YYYY').format('DD/MM/YYYY')
          : null,
        contractCode: this.apiParams.contractCode?.trim() || null,
        docId: this.apiParams.docId?.trim() || null,
        customerMobile: this.apiParams.customerMobile?.trim() || null,
        isFullPaid: this.apiParams.isFullPaid,
      };

      return _.omitBy(params, _.isNil);
    },

    setFilter() {
      const query = this.$route.query;

      if (_.isEmpty(query)) return;

      this.apiParams = {
        page: parseInt(query.page) || 1,
        limit: this.PAGE_LIMIT,
        storeId: query.storeId || null,
        fromDate: query.fromDate || MIN_RANGE_DATE,
        toDate: query.toDate || MAX_RANGE_DATE,
        contractCode: query.contractCode || null,
        docId: query.docId || null,
        customerMobile: query.customerMobile || null,
        isFullPaid: query.isFullPaid || null,
        contactId: query.contactId || null,
      };

      // Đồng bộ searchStock với storeId từ URL
      if (query.storeId && this.optionsStore.length > 0) {
        const selectedStore = this.optionsStore.find(
          (store) => store.id == query.storeId,
        );
        if (selectedStore) {
          this.searchStock = selectedStore.name;
        }
      } else if (!query.storeId) {
        this.searchStock = 'Tất cả cửa hàng';
      }
    },

    // API calls
    async fetchMainData() {
      if (this.onLoadingList) return;

      try {
        this.setFilter();

        const page = parseInt(this.$route.query.page) || 1;

        this.apiParams.page = page;
        this.apiParams.type = this.$route.params.mode;

        // Xử lý searchStock logic - chỉ reset storeId nếu không có trong URL query
        if (
          (!this.searchStock ||
            this.searchStock.trim() === '' ||
            this.searchStock === 'Tất cả cửa hàng') &&
          !this.$route.query.storeId // Chỉ reset nếu URL không có storeId
        ) {
          this.apiParams.storeId = null;
        }

        this.onLoadingList = true;

        const response = await ApiService.query(
          'debts/installment-bill-transactions',
          {
            params: { ...this.apiParams },
          },
        );

        const respData = response.data.data;
        this.mainList.data = respData.data || [];
        this.paginations = { ...respData.paginations };
      } catch (error) {
        this.handleError('Lỗi tải dữ liệu', error);
        this.mainList.data = [];
      } finally {
        this.onLoadingList = false;
      }
    },

    async fetchInstallments() {
      try {
        const params = { getFull: true };
        const response = await ApiService.query('/installments', { params });
        const listData = response.data.data.data || [];

        this.listInstallments = [
          { value: null, text: 'Tất cả dịch vụ trả góp' },
        ];
        listData.forEach((item) => {
          this.listInstallments.push({
            value: item.id,
            text: item.name,
          });
        });
      } catch (error) {
        this.handleError('Lỗi tải danh sách trả góp', error);
      }
    },

    updateUrlParams() {
      const params = this.getParamFilters();

      const cleanParams = _.omitBy(params, _.isNull);

      this.$router
        .push({
          name: this.$route.name,
          params: this.$route.params,
          query: cleanParams,
        })
        .catch(() => {});
    },

    async fetchStoreByUser() {
      try {
        const response = await ApiService.get('stores/get-by-user');

        if (response.data.status !== 1) {
          throw new Error('Invalid response status');
        }

        const stores = response.data.data.stores || [];

        if (stores.length === 1) {
          this.searchStock = stores[0].name;
          this.apiParams.storeId = stores[0].id;
          this.isDisabled = true;
        } else {
          this.optionsStore = [
            {
              id: null,
              name: 'Tất cả cửa hàng',
              shortName: 'Tat ca cua hang',
            },
            ...stores,
          ];

          this.filteredOptions = [...this.optionsStore];
          this.searchStock = 'Tất cả cửa hàng';
          this.apiParams.storeId = null;
        }

        // Fetch data after store setup
        await this.fetchMainData();
      } catch (error) {
        this.handleError('Lỗi tải danh sách cửa hàng', error);
      }
    },

    editModalPayment(item) {
      this.mbPaymentType = 'items';
      this.bill.billNumber = item.billNumber;
      this.$bvModal.show('md-debt');
    },

    showModalExcel() {
      this.mbPaymentType = 'items';
      this.$bvModal.show('modal-debt-excel');
    },

    linkToTransaction(bill, item) {
      this.$router.push({
        name: 'transaction',
        params: {
          mainModelProp: {
            contactType: '3',
            reconciliationDocType: '1',
            reconciliationDocItemId: item.id,
            reconciliationBillId: bill.id,
            reconciliationBillNumber: bill.billNumber,
            type: '1',
            contactId: item.paymentRefId,
            contactName: item.accountName,
            amount: item.amount,
            note: this.getNoteForPay(bill, item),
          },
          mode: 'cash',
          action: 'add',
          id: 'new',
        },
      });
    },

    // Store search methods
    onSelected(option) {
      if (option && option.item) {
        this.searchStock = option.item.name;
        this.apiParams.storeId = option.item.id;
      }
    },

    onInputChangeStore(text) {
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }

      // Debounce search
      this.searchTimer = setTimeout(() => {
        const searchText = (text || '').toLowerCase();
        this.searchStock = text || '';

        if (!searchText) {
          this.filteredOptions = [...this.optionsStore];
          return;
        }

        this.filteredOptions = this.optionsStore
          .filter((item) => {
            const name = (item.name || '').toLowerCase();
            const shortName = (item.shortName || '').toLowerCase();
            return name.includes(searchText) || shortName.includes(searchText);
          })
          .slice(0, 10);
      }, 300);
    },

    // Utility methods
    isShowRow(listData, item) {
      return _.findIndex(listData, ['id', item.id]) === 0;
    },

    isShow(conditions) {
      return checkPermissions(conditions);
    },

    getNoteForPay(bill, item) {
      return [
        'Nhận thanh toán từ dịch vụ trả góp',
        `Mã HĐ: ${bill.billNumber}`,
        `Dịch vụ: ${item.accountName}`,
        `Mã hợp đồng: ${item.paymentCode || ''}`,
      ].join('\n');
    },

    sumTotalAmount(field, bills) {
      if (!bills || !Array.isArray(bills)) return convertPrice(0);

      const sumAmount = _.sumBy(bills, (bill) => {
        const value = bill[field];
        return _.isNumber(value) ? value : parseFloat(value) || 0;
      });

      return convertPrice(sumAmount);
    },

    loadBreadcrumb() {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: 'Kế toán', route: 'accountant' },
        { title: 'Công nợ' },
        { title: this.title },
      ]);
    },

    // Error handling
    handleError(message, error) {
      console.error(message, error);
      const errorMessage =
        error?.response?.data?.message || error?.message || 'Đã xảy ra lỗi';
      this.makeToastFailure(`${message}: ${errorMessage}`);
    },
  },
};
</script>

<style lang="scss">
.debt-items {
  .icon:hover {
    background-color: #90c6fc;
  }

  .sttClass {
    width: 20px;
  }

  input {
    border: 1px solid #ced4da;
  }

  .date-style {
    display: flex;
    align-items: center;
  }

  .page-item.disabled {
    cursor: not-allowed;
    &.bv-d-xs-down-none {
      .page-link {
        margin: 0.35rem 0.25rem;
        text-align: center;
      }
    }
  }
}

.table th,
.table td {
  vertical-align: middle;
}
</style>
